const applets = [
    {
        "text": "Application",
        "icon": "/image/browser/fill-up.svg",
        "path": "applicationDraft",
        "id": "ApplicationDraftApplet",
        "category": "Sales"
    },
    {
        "text": "Mark Application",
        "icon": "/image/browser/mark.svg",
        "path": "markApplication",
        "id": "MarkApplication",
        "category": "Sales"
    },
    {
        "text": "Inbox",
        "icon": "/image/browser/inbox.svg",
        "path": "inbox",
        "id": "Inbox",
        "category": "Sales"
    },
    {
        "text": "Application history",
        "icon": "/image/browser/history.svg",
        "id": "ApplicationHistory",
        "path": "applicationHistory",
        "category": "Sales"
    },
    {
        "text": "Basic Data",
        "icon": "/image/browser/user-data.svg",
        "id": "BasicData",
        "path": "basicData",
        "category": "Sales"
    },
]


export default applets;